module.exports = __webpack_public_path__ + "static/media/September.2024 Dai Hung - Block 05.1a.3a8fdda4.pdf";